$(document).ready(function () {
    var w = window.innerWidth;
    var $navHeader = $(".nav-header");
    var isdesktop = $navHeader.attr('data-fixeddesktop') === 'True';
    var ismobile = $navHeader.attr('data-fixedmobile') === 'True';

    if ((isdesktop && ismobile) || (isdesktop && w > 991) || (ismobile && w < 991)) {
        $navHeader.addClass("fixed-nav-header");
    }
});

var resizeFixedHeaderTimeout;

$(window).resize(function () {
    clearTimeout(resizeFixedHeaderTimeout);
    resizeFixedHeaderTimeout = setTimeout(function () {
        var w = window.innerWidth;
        var $navHeader = $(".nav-header");
        var $header = $('header');
        var isdesktop = $navHeader.attr('data-fixeddesktop') === 'True';
        var ismobile = $navHeader.attr('data-fixedmobile') === 'True';

        if ((isdesktop && ismobile) || (isdesktop && w > 991) || (ismobile && w < 991)) {
            if (!$header.hasClass('fixed-nav-header')) {
                $navHeader.addClass("fixed-nav-header");
            }
        } else if ($header.hasClass('fixed-nav-header')) {
            $header.removeClass('fixed-nav-header').removeAttr('style');
            $(".breadcrumb-panel").removeAttr('style');
        }
    }, 250);
});

//adding meta viewport tag if does not exist.
(function ($) {
    $(document).ready(function () {
        var existsMeta = $('meta[name=viewport]');
        var metaTag = '<meta name="viewport" content="width=device-width, initial-scale=1">';
        if (!existsMeta.length) {
            $('head').append(sanitizeHtmlStrings(metaTag, {
                whiteList: {
                    meta: ["name", "content", "initial"]
                }
            }));
        }
    });
}(window.jQuery));

(function ($) {
    $(document).ready(function () {
        var english = /^[A-Za-z0-9-\s]*$/;
        var isRtl = function () {
            var lang = $('html').data('lang');
            switch (lang) {
                case "ar-EG":
                case "ar-DZ":
                case "ar-BH":
                case "ar-IQ":
                case "ar-JO":
                case "ar-KW":
                case "ar-LB":
                case "ar-LY":
                case "ar-MA":
                case "ar-OM":
                case "ar-QA":
                case "ar-SA":
                case "ar-SY":
                case "ar-TN":
                case "ar-AE":
                case "ar-YE":
                case "he-IL":
                case "fa-IR":
                case "ur-PK":
                    return true;
                default:
                    return false;
            }
        };
        if (isRtl) {
            var arlink = $('a.glyph-link');
            if (arlink.length) {
                $(arlink).each(function () {
                    if (english.test(this.innerHTML)) {
                        $(this).addClass("link-rtl");
                    }
                });
            }
        }
    });
}(window.jQuery));